import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getIncomeGraph = createAsyncThunk('homeGraph/getIncomeGraph',
  async ({ startDateMeta, endDateMeta, venueMeta, type }: IncomeGraphQuery) => {
    const url = `v1/reports/income-graph${serializeQueryParam({startDate: startDateMeta, endDate: endDateMeta, venueId: venueMeta})}`
    const response: AxiosResponse<IncomeGraphState[]> = await instance.get(url)
    return {
      type,
      data: [...response.data]
    }
  })

export const getCountGraph = createAsyncThunk('homeGraph/getCountGraph',
  async ({ startDateMeta, endDateMeta, venueMeta, typeMeta, type }: CountGraphQuery) => {
    const url = `v1/reports/count-graph${serializeQueryParam({startDate: startDateMeta, endDate: endDateMeta, venueId: venueMeta, countGraphType: typeMeta})}`
    const response: AxiosResponse<CountGraphState[]> = await instance.get(url)
    return {
      type,
      data: [...response.data]
    }
  })

